import {
    createMasterEvent,
    createMasterFloor,
    createStoreItem,
    getCategory,
    getSingleItem,
    getSingleMasterFloor,
    updateItem,
    updateMasterFloor,
  } from "_services";
  import { getGuest } from "_services/guestServices";
  import {
    CommonDate,
    CommonDatePicker,
    CommonInput,
    CommonModal,
    CustomSelect,
  } from "components";
  import { createEvent } from "features/masterService";
  import { errorSchema, utils } from "helper";
  import React, { useEffect, useMemo, useRef, useState } from "react";
  import toast from "react-hot-toast";
  import { useDispatch } from "react-redux";
  import { useNavigate } from "react-router-dom";
  
  const AddFloorModal = (props) => {
    const [form, setForm] = useState({
      name: "",
      category:"",
      current_stock:""
    });
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const nameRef = useRef();
    const startRef = useRef();
    const stockRef = useRef();
    
    const [formError, setFormError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [supervisorList,setSupervisorList] = useState([])
     const [filter, setFilter] = useState({
      
      });
  
    useEffect(() => {
      if (props?.addressId) {
        getFloorDetails(props?.addressId);
       
      }
    }, [props?.addressId]);
  
    useEffect(() => {
      if (nameRef.current) {
        nameRef.current.focus();
        getSuperVisorList()
      }
    }, []);
  
  
  
    const getFloorDetails = async (id) => {
      try {
        const res = await getSingleItem(id);
  
        if (res?.status === 200) {
          setForm({
            ...form,
            name: res?.results?.name,
            category:res?.results?.category,
      current_stock:res?.results?.current_stock
         
          });
        }
      } catch (error) {}
    };
  
  
    const getSuperVisorList = async (url = null) => {
      try {
       
        const filterParams = new URLSearchParams();
  
        Object.keys(filter).forEach(key => {
          if (filter[key]) {
            filterParams.append(key, filter[key]);
          }
        });
  
        const res = await getCategory(url,filterParams.toString());
  
        if (res?.status === 200) {
          const list = res?.results?.map((i)=>{
            return {
              ...i,
              label:i?.name,
              value:i?.id
            }
          })
          setSupervisorList(list);
          
        } else {
          toast.error(res.error);
        }
      } catch (error) {
        toast.error(error);
      } finally {
       
      }
    };
  
    const handleOnChange = async (name, value) => {
      setForm((prevForm) => {
        const updatedForm = {
          ...prevForm,
          [name]: value,
        };
  
        if (formError) {
          utils
            .checkFormError(
              {
                ...updatedForm,
              },
              errorSchema.itemSchema
            )
            .then((validationResult) => {
              if (validationResult === true) {
                setFormError("");
              } else {
                setFormError(validationResult);
              }
            });
        }
  
        return updatedForm;
      });
    };
  
    const handleSubmit = async () => {
      const validationResult = await utils?.checkFormError(
        form,
        errorSchema.itemSchema
      );
  
  
      if (validationResult === true) {
        setIsLoading(true);
        try {
          if (props?.addressId) {
            const res = await updateItem({
              payload: form,
              id: props?.addressId,
            });
  
            if (res.status === 200) {
              setIsLoading(false);
              toast.success(res.message);
              props?.closeModal();
              props?.callback();
            } else {
              toast.error(res.error);
            }
          } else {
            const res = await createStoreItem(form);
  
            if (res.status === 201) {
              setIsLoading(false);
              toast.success(res.message);
              props?.closeModal();
              props?.callback();
            } else {
              toast.error(res.error);
            }
          }
        } catch (error) {
          setIsLoading(false);
        }
      } else {
        setFormError(validationResult);
      }
    };
  
    const objectBid = {
      ...props,
      onSubmit: handleSubmit,
      disabled: isLoading || props?.eventView,
      isLoadding: isLoading,
    };
  
    const handleKey = (e, nextInputRef) => {
      if (e.key === "Enter") {
        e.preventDefault();
        if (nextInputRef) {
          nextInputRef.current.focus();
        } else {
          handleSubmit(e);
        }
      }
    };
  
    return (
      <>
        <CommonModal {...objectBid}>
          <div className="_plcMod_body" style={{ padding: "20px" }}>
            <div className="flxInr">
              <div className="singleDiv">
                <CommonInput
                  type="text"
                  label="Name"
                  placeholder="Enter Name"
                  name="name"
                  value={form?.name}
                  onChange={({ target: { name, value } }) => {
                    handleOnChange(name, value);
                  }}
                  focus={!!formError?.name}
                  error={formError.name}
                  ref={nameRef}
                  onKeyDown={(e) => handleKey(e, stockRef)}
                  disabled={props?.eventView}
                />
              </div>
              <div className="singleDiv">
                <CustomSelect
                  label="Category"
                  name="category"
                  placeholder="Select Category"
                  onSelect={(data) => {
                    handleOnChange("category", data.value);
                  }}
                  value={supervisorList?.length?supervisorList?.find((f)=>f?.value==form?.category):{label:"",value:""}}
                  options={supervisorList}
                  focus={!!formError?.category}
                  error={formError.category}
                  ref={stockRef}
                  onEnterSelect={() => startRef.current.focus()}
                
                />
              </div>
              <div className="singleDiv">
                <CommonInput
                  type="text"
                  label="Current Stock"
                  placeholder="Enter Current Stock"
                  name="current_stock"
                  value={form?.current_stock}
                  onChange={({ target: { name, value } }) => {
                    handleOnChange(name, value);
                  }}
                  focus={!!formError?.current_stock}
                  error={formError.current_stock}
                  ref={startRef}
                  onKeyDown={(e) => handleKey(e, null)}
                  disabled={props?.eventView}
                />
              </div>
              
            </div>
          </div>
        </CommonModal>
        <div className="offBack_drop"></div>
      </>
    );
  };
  
  export default AddFloorModal;
  